import { FC } from 'react'

// eslint-disable-next-line import/no-extraneous-dependencies
import { Button } from 'baby-design'

import GiftIcon from './GiftIcon.svg'
import styles from './EmptyState.styles.scss'

const NoGiftsMessage: FC<{ searchFilter: string | null }> = ({
  searchFilter,
}) => {
  const heading = !searchFilter
    ? 'No gifts, yet.'
    : `No gifts matching "${searchFilter}"`

  const subHeading = !searchFilter
    ? 'When gifts from your registry are purchased they will appear here.'
    : 'Check your spelling or try a different search term.'

  return (
    <div className={styles.EmptyState__NoGiftsMessage}>
      <GiftIcon />
      <div className={styles.EmptyState__NoGiftsMessage__Text}>
        <div className={styles.EmptyState__NoGiftsMessage__Text__Heading}>
          {heading}
        </div>
        <div className={styles.EmptyState__NoGiftsMessage__Text__SubHeading}>
          {subHeading}
        </div>
      </div>
    </div>
  )
}

const RegistryLink: FC<{ registryUrl: string | undefined }> = ({
  registryUrl,
}) => (
  <Button
    data-testid="RegistryLink"
    href={registryUrl}
    size="md"
    variant="tertiary"
  >
    View your registry
  </Button>
)

export type EmptyStateProps = {
  registryUrl: string | undefined
  searchFilter: string | null
}
const EmptyState: FC<EmptyStateProps> = ({ registryUrl, searchFilter }) => (
  <div className={styles.EmptyState}>
    <NoGiftsMessage searchFilter={searchFilter} />
    <RegistryLink registryUrl={registryUrl} />
  </div>
)

export default EmptyState
